import clsx from 'clsx'
import React, { HTMLProps } from 'react'

import { Icon } from '@wartek-id/icon'
import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

type Variant = 'default' | 'compact'
interface Step {
  label: string
  number?: string | number
  isActive?: boolean
  isDone?: boolean
}

interface PropsHorizontalSteps extends HTMLProps<HTMLDivElement> {
  variant?: Variant
  fullWidth?: boolean
  steps: Step[]
}

const HorizontalSteps = ({
  variant = 'default',
  fullWidth = false,
  steps,
  className,
  ...otherProps
}: PropsHorizontalSteps) => {
  return (
    <div className={clsx('flex items-center gap-3', className)} {...otherProps}>
      {steps.map((step, i) => (
        <React.Fragment key={`horizontal-step-${i}`}>
          <div
            className={clsx(
              'flex items-center gap-2',
              variant === 'default' && 'min-w-fit',
              variant === 'compact' && '!w-[100px] flex-col text-center'
            )}
            data-testid={`horizontal-step-${i}`}
          >
            <div
              className={clsx(
                'flex items-center justify-center rounded-full p-4',
                {
                  'bg-[#0B5FEF]': step.isActive,
                  'border-2 border-blue-40': !step.isActive && !step.isDone,
                  'border-2 border-[#4CA375]': step.isDone,
                }
              )}
            >
              <div className="absolute flex">
                {step.isDone ? (
                  <Icon color="success" data-testid="icon-check">
                    check
                  </Icon>
                ) : (
                  <Text
                    variant="action"
                    color={
                      step.isActive || (variant === 'compact' && step.isActive)
                        ? 'inverse'
                        : 'disabled'
                    }
                  >
                    {step.number || i + 1}
                  </Text>
                )}
              </div>
            </div>
            <Text
              variant={variant === 'compact' ? 'action' : 'heading-sm'}
              color={step.isDone || step.isActive ? 'default' : 'disabled'}
            >
              {step.label}
            </Text>
          </div>
          {i < steps.length - 1 && (
            <Separator className={clsx('!bg-gray-50', !fullWidth && '!w-9')} />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default HorizontalSteps
